const LoadableEntityState = {
  Initial: 'Initial',
  Loading: 'Loading',
  Loaded: 'Loaded',
  Fail: 'Fail',
  Stale: 'Stale',
};

export default LoadableEntityState;
